import { styled, withStyles } from "@mui/styles";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Styles } from "src/styles/material-styles";
import * as articleActions from 'src/redux/actions/articles';
import PropTypes from 'prop-types';
import { AbilityContext } from "src/config/ability-context";
import Api from "src/services/api";
import { Box, Button, CircularProgress, Container, darken, Divider, Grid, IconButton, ImageList, InputAdornment, TextField, Typography, Chip, Breadcrumbs, List, Collapse, ListItemButton, Tooltip, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import Header from "src/components/header-external";
import { PapiroConsole } from "src/utils/papiroConsole";
import { ArrowForwardIos, AttachFile, ExpandLess, ExpandMore, Search } from "@mui/icons-material";
import Footer from "src/components/footer-external";
import * as FileService from 'src/services/attachment.service';
import Modal from "src/components/modal-external/modal-principal";
import MyMaterialTable from 'src/components/table'
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import DynamicArticles from "src/components/dynamic-articles-external";
import LogoMarca from 'src/images/new-logo2-cmtech.png'
import { browserHistory } from "src/helpers/history";
import { getTagsAndEnableTagsOnArticles } from '../../services/tags.service'

const StyledTextField = styled(TextField)({
    backgroundColor: "#fff",
    borderRadius: "14px",
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    }
})

class ArticleExternal extends Component {
    constructor(props) {
        super(props)

        this.initialState = {
            id: 0,
            hirerid: 0,
            articlesectionid: 0,
            title: '',
            content: '',
            subtitle: '',
            articlesattachments: [],
        }

        this.state = {
            article: this.initialState,
            clientportal: {},
            articlesections: [],
            articleSectionsExternalList: [],
            articleSectionsExternalBreadCrumb: [],
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            searchvalue: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: '',
            tags: [],
            feedbackState: 'initial',
            feedbackReason: '',
            feedbackOptions: [],
        }

        this.handleChange = this.handleChange.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.getFile = this.getFile.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
        this.handleBreadCrumbClick = this.handleBreadCrumbClick.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
        this.getArticleSectionsExternalList = this.getArticleSectionsExternalList.bind(this)
        this.renderSectionsAndArticlesBreadCrumb = this.renderSectionsAndArticlesBreadCrumb.bind(this)
        this.renderLabelSectionsAndArticles = this.renderLabelSectionsAndArticles.bind(this)
    }

    async componentWillReceiveProps() {
        await this.componentDidMount()
    }

    async componentDidMount() {
        document.title = this.state.appName;

        this.setState({ loading: true })
        this.resetFeedbackState();

        await this.getHirerId()
        await this.getClientPortal()
        await this.fetchFeedbackOptions()
        await this.getArticle()
        await this.getArticleSection()
        await this.getTagsAndEnableTagsOnArticles(this.state.article.id);
        await this.getArticleSectionsExternalList();
        this.formattedArticleSectionsExternalBreadCrumb()

        this.setState({ loading: false })
    }
    fetchFeedbackOptions = async () => {
        try {
            const result = await Api.get('feedback-article/get-all');
            if (result.data.success) {
                console.log("Opções de feedback carregadas:", result.data.data);
                this.setState({ feedbackOptions: result.data.data });
            } else {
                throw new Error("Não foi possível carregar as opções de feedback.");
            }
        } catch (err) {
            console.error("Erro ao buscar opções de feedback:", err);
        }
    }


    sendFeedback = async (feedbackPayload) => {
        const { article } = this.state;
        const { intl } = this.props;

        const formData = new FormData();
        formData.append('ArticleId', article.id);
        formData.append('WasHelpful', feedbackPayload.WasHelpful);
        formData.append('Description', feedbackPayload.Description);


        if (feedbackPayload.ReasonId !== null && feedbackPayload.ReasonId !== undefined) {
            formData.append('ReasonId', feedbackPayload.ReasonId);
        }

        try {
            const result = await Api.post('articles-rate', formData);

            if (result.data && result.data.success) {
                this.setState({ feedbackState: 'thankyou' });
            } else {
                throw new Error(result.data.errors ? result.data.errors[0] : 'Falha ao enviar feedback.');
            }
        } catch (err) {
            console.error('Erro ao enviar feedback:', err);
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: err.message || intl.formatMessage({ id: "process.error" })
            });
        }
    }

    handleInitialFeedback = (wasHelpful) => {
        if (wasHelpful) {
            this.sendFeedback({
                WasHelpful: true,
                ReasonId: null,
                Description: ''
            });
        } else {
            this.setState({ feedbackState: 'detailed' });
        }
    }

    handleFeedbackSubmit = (e) => {
        e.preventDefault();
        const { feedbackReason } = this.state;

        if (feedbackReason) {
            this.sendFeedback({
                WasHelpful: false,
                ReasonId: feedbackReason,
                Description: ''
            });
        } else {
            this.setState({
                openNotification: true,
                notificationVariant: 'warning',
                notificationMessage: this.props.intl.formatMessage({ id: "article.feedback.pleaseselectreason" })

            });
        }
    }

    resetFeedbackState = () => {
        this.setState({ feedbackState: 'initial', feedbackReason: '' });
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    async getArticle() {
        var { id } = this.props.match.params
        const { intl } = this.props

        await Api.get(`articles/external/${id}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        article: result.data.data
                    })
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getArticleSection() {

        const { intl } = this.props

        await Api.get(`articles-section/parents/${this.state.article.sectionid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        articlesections: result.data.data
                    })
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getArticleSectionsExternalList() {
        const { intl } = this.props;

        const { articlesections } = this.state;

        let articlesectionidlist = [];

        if (articlesections && articlesections.length > 0) {
            articlesectionidlist = articlesections.map((item) => item.id);
        }

        if (articlesectionidlist.length <= 0) return;

        let url = `articles/paginatebyarticlesection/breadcrumbs?hirerid=${this.state.hirerid}&articlesectionidlist=${articlesectionidlist.join(',')}`;

        await Api.get(url)
            .then(result => {
                if (result.data && result.data.success) {
                    let list = result.data.data;

                    this.setState({
                        articleSectionsExternalList: list
                    })

                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })

                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })

        this.setState({ loading: false });
    }

    formattedArticleSectionsExternalBreadCrumb() {
        var { id: currentArticleId } = this.props.match.params;

        const { articlesections, articleSectionsExternalList } = this.state;

        let data = [];

        if (articlesections && articlesections.length <= 0) return data;

        articlesections.forEach((section) => {
            let sectionData = {
                ...section,
                open: false,
                mapName: section.name,
                mapArticles: [],
            };

            data.push(sectionData);
        });

        if (articleSectionsExternalList && articleSectionsExternalList.length > 0) {
            articleSectionsExternalList.forEach(article => {
                const section = data.find(s => s.id === article.sectionid);

                const isActiveSection = article.id === parseInt(currentArticleId);

                if (section) {
                    const mapName = `${section.name}/${article.title}`;

                    const _article = {
                        ...article,
                        mapName
                    }

                    section.open = isActiveSection ? true : section.open;
                    section.mapArticles.push(_article);
                }
            });
        }

        data = data.filter(section => section && section?.mapArticles?.length > 0);

        this.setState({
            articleSectionsExternalBreadCrumb: data
        });
    }

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        clientportal: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        this.getFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ logoimagesrc: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    downloadFile = async (attachment) => {
        const intl = this.props.intl
        let url = await FileService.getFileDownloadLink(attachment.attachmentid);
        if (url && url.data && url.data.data && url.data.success) {
            window.open(`${url.data.data}`, "_blank")
        } else {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" }),
            })
        }
    }

    useStyles = () => {
        return withStyles({
            ImageList: {
                width: "100%",
                height: 100,
            },
        })
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchvalue, 'text')
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    handleBreadCrumbClick = (articlesectionid) => {
        this.props.addCurrentSearch(articlesectionid, 'articlesectionid')
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    handleGoToNewArticle = (articlesectionid) => {
        this.props.history.push(`/${this.props.match.params.lang}/article-external/${articlesectionid}`)
    }

    handleBack = () => {
        const { history, match } = this.props;
        if (history.length > 1) {
            browserHistory.goBack();
        } else {
            history.push(`/${match.params.lang}/client-portal-external`);
        }
    }

    async getTagsAndEnableTagsOnArticles(id) {

        let result = await getTagsAndEnableTagsOnArticles(id)
        if (result && result.success) {
            this.setState({
                enableTagsOnArticles: result.data.enabletagsonarticles,
                tags: result.data.tags
            })
        }
        else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    result.response && result.response.data && result.response.data.errors
                        ? result.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            });

            Api.kickoff(result);
        }
    }

    handleTagClick(tag) {
        this.props.addCurrentSearch(tag, "text");
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`);
    }

    handleClickOpenSectionBreadCrumbs(id) {
        const { articleSectionsExternalBreadCrumb } = this.state;

        let helpNewArticle = [...articleSectionsExternalBreadCrumb];

        const getArticle = helpNewArticle.findIndex(a => a.id === id);

        helpNewArticle[getArticle].open = !helpNewArticle[getArticle].open;

        this.setState({
            articleSectionsExternalBreadCrumb: helpNewArticle
        });
    };

    renderSectionsBreadCrumb = () => {
        const { articlesections, article, clientportal } = this.state;

        const defaultClientColor = clientportal.defaultcolor ? clientportal.defaultcolor : null;

        const actualPage = {
            ...article,
            isActualPage: true,
            id: article.title,
            name: article.title,
        };

        const _articlesections = [...articlesections, actualPage];

        const isOnlyActualPage = _articlesections.every(item => item.isActualPage === true);

        return (
            <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ArrowForwardIos fontSize="small" sx={{ color: defaultClientColor ? defaultClientColor : null }} />}
            >
                {_articlesections.map((section, _) => {
                    const isActive = section?.isActualPage && !isOnlyActualPage;

                    const isActiveProps = isActive
                        ? { sx: { color: defaultClientColor } }
                        : {
                            onClick: () => this.handleBreadCrumbClick(section.id),
                            sx: {
                                cursor: "pointer",
                                color: isOnlyActualPage && defaultClientColor ? defaultClientColor : null,
                                "&:hover": {
                                    textDecoration: "underline",
                                }
                            }
                        };

                    return (
                        <Typography
                            key={section.id}
                            variant="h5"
                            {...isActiveProps}
                        >
                            {section.name}
                        </Typography>
                    );
                })}
            </Breadcrumbs>
        );
    }

    renderLabelSectionsAndArticles(props) {
        const { id, open, mapName, mapArticles } = props;

        const hasMapArticles = mapArticles && mapArticles.length > 0;

        let icon = null;
        if (open != null && hasMapArticles) {
            icon = open ? <ExpandLess /> : <ExpandMore />;
        }

        const isActiveProps = hasMapArticles
            ? { onClick: () => this.handleClickOpenSectionBreadCrumbs(id) }
            : { onClick: () => this.handleBreadCrumbClick(id) };

        if (hasMapArticles) {
            return (
                <>
                    <li>
                        <ListItemButton {...isActiveProps} sx={{ justifyContent: 'space-between' }}>
                            <Tooltip title={mapName} placement="right" arrow>
                                <Typography children={mapName} noWrap />
                            </Tooltip>

                            {icon}
                        </ListItemButton>
                    </li>

                    <Collapse component="li" in={open} timeout="auto" unmountOnExit>
                        <List disablePadding>
                            {mapArticles.map((article) => this.renderArticlesCollapseToSection(article))}
                        </List>
                    </Collapse>
                </>
            )
        }

        return (
            <li>
                <ListItemButton {...isActiveProps} sx={{ justifyContent: 'space-between' }}>
                    <Tooltip title={mapName} placement="right" arrow>
                        <Typography children={mapName} noWrap />
                    </Tooltip>

                    {icon}
                </ListItemButton>
            </li>
        );
    }

    renderArticlesCollapseToSection = (props) => {
        const { article, clientportal } = this.state;

        const defaultClientColor = clientportal.defaultcolor ? clientportal.defaultcolor : null;

        const { id, title } = props;

        const currentArticleId = article.id;

        const isActive = id === currentArticleId;

        const isActiveProps = isActive
            ? { style: { cursor: "default" } }
            : { onClick: () => this.handleGoToNewArticle(id) };

        return (
            <li>
                <ListItemButton
                    {...isActiveProps}
                    sx={{
                        pl: 4,
                    }}>
                    <Tooltip title={title} placement="right" arrow>
                        <Typography children={title} noWrap sx={{ color: isActive && defaultClientColor ? defaultClientColor : null }} />
                    </Tooltip>
                </ListItemButton>
            </li>
        );
    }

    renderSectionsAndArticlesBreadCrumb = () => {
        const { articleSectionsExternalBreadCrumb } = this.state;

        return (
            <List sx={{ width: '100%', }} component="nav" aria-labelledby="nested-list-subheader" >
                {articleSectionsExternalBreadCrumb.map(this.renderLabelSectionsAndArticles)}
            </List>
        )

    }

    render() {

        const { classes, intl } = this.props

        const { article, clientportal, hirerid, logoimagesrc, articleSectionsExternalBreadCrumb, loading } = this.state

        const classes2 = this.useStyles()

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        const hasArticleSectionsExternalBreadCrumb =
            articleSectionsExternalBreadCrumb
            && articleSectionsExternalBreadCrumb.length > 0
            && !loading;

        return (
            <div className={classes.root}>

                <main
                    className={classes.contentExternal}
                >
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0 }}>
                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container spacing={4}>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                />

                                <Grid item sm={12} >
                                    <div style={{
                                        display: "block",
                                        width: "100vw",
                                        textAlign: "center",
                                        alignContent: "center",
                                        backgroundColor: clientportal.defaultcolor,
                                        paddingBlock: "20px"
                                    }}>{
                                            clientportal.enablesearch &&
                                            <StyledTextField
                                                name="searchvalue"
                                                label={intl.formatMessage({ id: "search" })}
                                                value={this.state.searchvalue}
                                                onChange={this.handleChange}
                                                sx={{ width: "60vw" }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={_ => this.searchArticle()}>
                                                                <Search />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        }
                                    </div>
                                </Grid>

                                <Grid item sm={12} container marginX="20vw" style={{ maxWidth: '60vw' }} >
                                    <Grid item sm={1}>
                                        {!this.state.loading && clientportal &&
                                            (clientportal.defaultcolor && clientportal.defaultcolor.length > 0) ?
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleBack}
                                                sx={{
                                                    backgroundColor: clientportal.defaultcolor,
                                                    color: '#fff',
                                                    textTransform: 'none',
                                                    '&:hover': {
                                                        backgroundColor: darken(clientportal.defaultcolor, 0.2),
                                                    },
                                                }}
                                            >
                                                {intl.formatMessage({ id: "back" })}
                                            </Button>
                                            :
                                            !this.state.loading && clientportal &&
                                            <Button
                                                variant="contained"
                                                color="success"
                                                onClick={this.handleBack}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                {intl.formatMessage({ id: "back" })}
                                            </Button>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid container marginX={hasArticleSectionsExternalBreadCrumb ? "10vw" : "20vw"} paddingTop={3} spacing={hasArticleSectionsExternalBreadCrumb ? 1 : 6} maxWidth={'70vw'} justifyContent={"center"}>
                                    {hasArticleSectionsExternalBreadCrumb &&
                                        <Grid item container sm={2.5}>
                                            {this.renderSectionsAndArticlesBreadCrumb()}
                                        </Grid>
                                    }

                                    <Grid item container sm={hasArticleSectionsExternalBreadCrumb ? 9.5 : 12} spacing={6}>
                                        <Grid item sm={12} display="flex" flexDirection="row">
                                            {this.renderSectionsBreadCrumb()}
                                        </Grid>

                                        <Grid item sm={12}>
                                            <div>
                                                <Typography variant="h2">{article.title}</Typography>
                                                <Typography marginY="12px" variant="h4">{article.subtitle}</Typography>
                                                <Divider />
                                            </div>
                                        </Grid>

                                        <Grid item sm={12}>
                                            <div dangerouslySetInnerHTML={{ __html: article.content }} />

                                            <Box className="feedback-container" sx={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                                                {this.state.feedbackState === 'initial' && (
                                                    <Box id="initial-feedback-buttons">
                                                        <Typography variant="h6"><FormattedMessage id="article.feedback.wasithelpful" /></Typography>
                                                        <Button variant="outlined" sx={{ marginRight: '10px', marginTop: '10px' }} onClick={() => this.handleInitialFeedback(true)}>
                                                            <FormattedMessage id="yes" />
                                                        </Button>
                                                        <Button variant="outlined" sx={{ marginTop: '10px' }} onClick={() => this.handleInitialFeedback(false)}>
                                                            <FormattedMessage id="no" />
                                                        </Button>
                                                    </Box>
                                                )}

                                                {this.state.feedbackState === 'detailed' && (
                                                    <Box id="feedback-details">
                                                        <Typography variant="h6"><FormattedMessage id="article.feedback.thankyouevaluation" /></Typography>
                                                        <FormControl component="fieldset" sx={{ marginTop: '20px', width: '100%' }}>
                                                            <FormLabel
                                                                component="legend"
                                                                sx={{
                                                                    fontSize: '1.8rem',    
                                                                    fontWeight: 'bolder',    
                                                                    '&.Mui-focused': {color: 'rgba(0, 0, 0, 1)'},
                                                                    marginBottom: '10px'   
                                                                }}
                                                            >
                                                                <FormattedMessage id="article.feedback.title" />
                                                            </FormLabel>
                                                            <RadioGroup
                                                                name="feedback_reason"
                                                                value={this.state.feedbackReason}
                                                                onChange={(e) => this.setState({ feedbackReason: e.target.value })}
                                                                sx={{ marginTop: '10px' }}
                                                            >
                                                                {this.state.feedbackOptions.map(option => (
                                                                    <FormControlLabel
                                                                        key={option.id}
                                                                        value={option.id.toString()}
                                                                        control={<Radio />}
                                                                        label={<span dangerouslySetInnerHTML={{ __html: option.description }} />}
                                                                        labelPlacement="end"
                                                                        sx={{
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            alignItems: "center",
                                                                            gap: "6px",
                                                                            ".MuiFormControlLabel-label": {
                                                                                margin: 0,
                                                                                lineHeight: 1,
                                                                            },
                                                                        }}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                            <Box sx={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    onClick={this.resetFeedbackState}
                                                                >
                                                                    <FormattedMessage id="article.feedback.changeanswer" />
                                                                </Button>
                                                                <Button
                                                                    variant="outlined"
                                                                    onClick={this.handleFeedbackSubmit}
                                                                >
                                                                    <FormattedMessage id="article.feedback.send" />
                                                                </Button>
                                                            </Box>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {this.state.feedbackState === 'thankyou' && (
                                                    <Typography variant="h6" id="feedback-thank-you">
                                                        <FormattedMessage id="article.feedback.sent" />
                                                    </Typography>
                                                )}
                                            </Box>                                        </Grid>

                                        <Grid item sm={12}>
                                            {article.articlesattachments.length > 0 && (
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <div className={classes.attachmentsBox}>
                                                        <label>{<FormattedMessage id="attachments" />}</label>
                                                        <ImageList
                                                            cellHeight={100}
                                                            className={classes2.ImageList}
                                                            cols={1}
                                                        >
                                                            <ul>
                                                                {article.articlesattachments.map((file) => {
                                                                    return (
                                                                        <li
                                                                            key={file.attachmentid}
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <AttachFile />
                                                                            <Button onClick={() => this.downloadFile(file)}>
                                                                                {file.name}
                                                                            </Button>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        </ImageList>
                                                    </div>
                                                </Grid>
                                            )}
                                        </Grid>

                                        {this.state.enableTagsOnArticles &&
                                            <Grid item xs={12} sm={12} mb={2}>
                                                <Box sx={{ mb: 3 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: "#6b7280",
                                                            fontWeight: 600,
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.05em",
                                                            mb: 1,
                                                            display: "block",
                                                        }}
                                                    >
                                                        Tags
                                                    </Typography>
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                        {this.state.tags.map((tag, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={tag}
                                                                onClick={() => this.handleTagClick(tag)}
                                                                color="primary"
                                                                variant="outlined"
                                                                sx={{ cursor: "pointer" }}

                                                            />
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid container marginX="20vw" spacing={6} paddingTop={6} style={{ maxWidth: '60vw' }} >
                                    <Grid item container direction="row" spacing={2} justifyContent="space-around">
                                        {
                                            clientportal.showpromotedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "promoted.articles" })}
                                                hirerid={hirerid}
                                                type="promoted"
                                                count={clientportal.promotedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showbestratedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "best.rated.articles" })}
                                                hirerid={hirerid}
                                                type="bestrated"
                                                count={clientportal.bestratedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showmostviewedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "most.viewed.articles" })}
                                                hirerid={hirerid}
                                                type="mostviewed"
                                                count={clientportal.mostviewedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showrecentarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "recent.articles" })}
                                                hirerid={hirerid}
                                                type="recent"
                                                count={clientportal.recentarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <Modal
                            intl={intl}
                            title={intl.formatMessage({ id: "choose.form" })}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            children={
                                <Box sx={{ minHeight: '50px' }}>
                                    <MyMaterialTable
                                        title=""
                                        columns={[
                                            { title: 'Id', field: 'id', width: 40 },
                                            { title: intl.formatMessage({ id: "title" }), field: 'title' },
                                            { title: intl.formatMessage({ id: "organization" }), field: 'OrganizationText' },
                                            { title: 'Rota', field: 'RouteText' },
                                        ]}
                                        rowClick={(event, rowData) => {
                                            window.open(`${rowData.RouteText}`, '_blank')
                                        }}
                                        data={this.state.calledServiceSettingsList}
                                    />
                                </Box>
                            }
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

ArticleExternal.propTypes = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ArticleExternal)));
ArticleExternal.contextType = AbilityContext;